export enum LIST_PAGINATED_TASKS_COLUMNS {
  NAME = 'NAME',
}

export type ListTaskParams = {
  page?: number;
  lenght?: number;
  query?: string;
  orderColumn?: LIST_PAGINATED_TASKS_COLUMNS;
  orderDirection?: 'ASC' | 'DESC';
};
